module.exports = __webpack_public_path__ + "img/journeyBlack.14b60ecb.gif";